export const INPUT_NAMES = {
  TILLAGE: "tillage",
  CARBON_INPUT: "carbonInput",
};
